import React, { useState } from 'react';
import axios from 'axios';
import ghanaImage from './igfff-01.png';
import { config } from './config/api.js';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

const LoginPage = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showReset, setShowReset] = useState(false);
  const [resetIdentifier, setResetIdentifier] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [resetError, setResetError] = useState('');
  const [resetLoading, setResetLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await axios.post(`${API_BASE_URL}/users/login`, { username, password }, config);

      if (res.data.status === 'inactive') {
        setError('Account deactivated. Contact admin.');
      } else if (res.data.role_name === 'super_admin' || res.data.role_name === 'mmda' || res.data.role_name === 'MMDA' || res.data.role_name === 'field_officer') {

        onLogin(res.data);
      } else {

        setError('Access denied. Only SuperAdmins and MMDA Admins can login.');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  const openReset = () => {
    setShowReset(true);
    setResetIdentifier('');
    setResetMessage('');
    setResetError('');
  };

  const closeReset = () => {
    setShowReset(false);
  };

  const submitReset = async (e) => {
    e.preventDefault();
    setResetError('');
    setResetMessage('');
    if (!resetIdentifier.trim()) {
      setResetError('Please enter your email or username.');
      return;
    }
    try {
      setResetLoading(true);
      // Conventional endpoint; adjust on backend if needed
      const res = await axios.post(`${API_BASE_URL}/users/forgot-password`, { identifier: resetIdentifier.trim() }, config);
      setResetMessage(res.data?.message || 'If an account exists, a reset link has been sent.');
    } catch (err) {
      if (err.response?.status === 404) {
        setResetError('Password reset is not available. Contact an administrator.');
      } else {
        setResetError(err.response?.data?.error || 'Could not request reset. Try again later.');
      }
    } finally {
      setResetLoading(false);
    }
  };

  return (
    <>
      <div style={{ minHeight: '90vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(to bottom,  #1976d2 50%, #ffffff 50%)' }}>
        <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: 32, width: 330 }}>
          <center>
              <img src={ghanaImage} alt="Ghana" style={{ width: '60%', height: 'auto', borderRadius: 8, maxWidth: '200px' }} />
          </center>
          <h2 style={{ textAlign: 'center', marginBottom: 24, color: '#1976d2' }}>Admin Login</h2>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={e => setUsername(e.target.value)}
                style={{ width: '93%', padding: '10px 12px', borderRadius: 8, border: '1px solid #ccc', fontSize: 15 }}
              />
            </div>
            <div style={{ marginBottom: 8 }}>
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                style={{ width: '93%', padding: '10px 12px', borderRadius: 8, border: '1px solid #ccc', fontSize: 15 }}
              />
            </div>
            <div style={{ marginBottom: 16, textAlign: 'right' }}>
              <button
                type="button"
                onClick={openReset}
                style={{ background: 'none', border: 'none', color: '#1976d2', cursor: 'pointer', fontSize: 13, padding: 0 }}
              >
                Forgot password?
              </button>
            </div>
            <button type="submit" style={{ width: '100%', padding: '10px 12px', borderRadius: 8, background: '#1976d2', color: '#fff', fontWeight: 600, fontSize: 16, border: 'none', boxShadow: '0 2px 8px rgba(25,118,210,0.08)', cursor: 'pointer' }}>Login</button>
            {error && <div style={{ color: '#d32f2f', marginTop: 16, textAlign: 'center' }}>{error}</div>}
          </form>
        </div>

        {showReset && (
          <div
            onClick={closeReset}
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
          >
            <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', width: 360, borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.15)', padding: 20 }}>
              <h3 style={{ marginTop: 0, marginBottom: 8, color: '#1976d2' }}>Reset password</h3>
              <p style={{ marginTop: 0, color: '#555', fontSize: 14 }}>Enter your email and we'll send instructions if an account exists.</p>
              <form onSubmit={submitReset}>
                <input
                  type="text"
                  placeholder="Email"
                  value={resetIdentifier}
                  onChange={(e) => setResetIdentifier(e.target.value)}
                  style={{ width: '95%', padding: '10px 12px', borderRadius: 8, border: '1px solid #ccc', fontSize: 14 }}
                />
                {resetError && <div style={{ color: '#d32f2f', marginTop: 10 }}>{resetError}</div>}
                {resetMessage && <div style={{ color: '#2e7d32', marginTop: 10 }}>{resetMessage}</div>}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
                  <button type="button" onClick={closeReset} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #ccc', background: '#fff', cursor: 'pointer', color: '#1976d2' }}>Cancel</button>
                  <button type="submit" disabled={resetLoading} style={{ padding: '8px 12px', borderRadius: 8, border: 'none', background: '#1976d2', color: '#fff', cursor: 'pointer', opacity: resetLoading ? 0.8 : 1 }}>
                    {resetLoading ? 'Sending...' : 'Send reset link'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
      <Copyright />
    </>
  );
};

const currentYear = new Date().getFullYear();
const copyrightText = `© ${currentYear} IGF.com. All rights reserved.`;

const Copyright = () => (
  <div style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: '#777' }}>
    © 2025 iGF360. Powered by{' '}
    <a
      href="https://www.Techland.com.gh"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: '#1976d2', textDecoration: 'none' }}
      onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
      onMouseOut={(e) => e.target.style.textDecoration = 'none'}
    >
      Techland
    </a>
    {' '}IT Solutions Ltd
  </div>
);

export default LoginPage;
